import Ease from '@CS/utils/Easing';
import { Theme } from '@/theme/Theme';
import styled, { css } from 'styled-components';

export const TRANSITION_DURATION = 750;
export const FADE_DURATION = 500;

type PopupOverlayAttributes = {
  opacity: number | string;
  $visible: boolean;
  $overlay: boolean;
};

export const PopupOverlay = styled.aside<PopupOverlayAttributes>(
  ({ $visible, $overlay, opacity }) => css`
    transition: background-color ${FADE_DURATION}ms 250ms;
    background-color: rgb(0 0 0 / 0);

    position: fixed;
    height: 100%;
    width: 100%;

    z-index: 2;
    padding: 0;

    margin: 0;
    inset: 0;

    > button:last-child {
      transition: opacity ${FADE_DURATION}ms;
      position: absolute;

      bottom: 40px;
      opacity: 0;

      right: 0px;
      left: 0px;

      > svg:only-child {
        height: auto;
        width: 24px;
      }
    }

    ${$visible &&
    css`
      ${$overlay &&
      css`
        transition-delay: 0ms;
        background-color: rgb(0 0 0 / ${opacity});
      `}

      > dialog {
        transition-timing-function: ${Ease.Out.Sine};
        transform: translate(-50%, 0px);
        transition-delay: 250ms;
        opacity: 1;
      }

      > button:last-child {
        transition-delay: ${TRANSITION_DURATION}ms;
        opacity: 1;
      }
    `}
  `
);

type PopupContainerAttributes = {
  $low?: boolean;
};

export const PopupContainer = styled.dialog<PopupContainerAttributes>(
  ({ $low }: PopupContainerAttributes) => css`
    transition:
      opacity ${FADE_DURATION}ms,
      transform ${FADE_DURATION}ms ${Ease.In.Sine};

    background-color: ${Theme.color.white};
    transform: translate(-50%, -25px);

    // max-height: calc(76.4vmax - 40px);
    // bottom: calc(11.737vmax + 100px);

    will-change: transform, opacity;
    backface-visibility: hidden;
    transform-origin: center;

    border-radius: 15px;
    isolation: isolate;
    position: absolute;

    min-height: 230px;
    min-width: 272px;
    max-width: 365px;

    display: block;
    bottom: 165px;
    border: none;

    opacity: 0;
    width: 85%;
    padding: 0;

    margin: 0;
    left: 50%;
    top: auto;

    &::after {
      clip-path: circle(50% at 50% calc(-50% + 25px));
      transform: translateY(calc(100% - 1px));
      background-color: ${Theme.color.white};

      pointer-events: none;
      aspect-ratio: 1 / 1;
      position: absolute;

      height: auto;
      width: 100%;

      z-index: -1;
      content: '';
      bottom: 0;
    }

    ${$low &&
    css`
      bottom: 9.39vmax;
    `}
  `
);

export const PopupHeader = styled.header`
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  aspect-ratio: 33 / 23;
  width: 100%;
`;
